var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0.85,
    clipPath: "url(#time_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .03a8 8 0 1 0 .001 16A8 8 0 0 0 8 .03m0 14.643A6.644 6.644 0 0 1 8 1.387a6.644 6.644 0 0 1 0 13.286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.12 10.289 8.573 8.448v-4.42a.143.143 0 0 0-.143-.143h-.858a.143.143 0 0 0-.143.143v4.918c0 .046.021.09.059.116l2.953 2.154a.144.144 0 0 0 .2-.03l.51-.697a.14.14 0 0 0-.031-.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "time_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .03h16v16H0z"
  })))));
};
export default SvgTime;